import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container } from '@mui/material';
import Windows from '../sections/@dashboard/monitorGraph/windows/Windows';

export default function WindowsGraphPage() {
  return (
    <>
      <Helmet>
        <title>MonitorGraph| WatchNod</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Container maxWidth="xl">
        <Windows />
      </Container>
    </>
  );
}
